import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentryService } from './services/sentry.service';

@NgModule({
  imports: [CommonModule],
  providers: [SentryService],
})
export class ErrorLoggerModule {}
